export default "__VITE_ASSET__D5epXdva__"